module.exports = __webpack_public_path__ + "static/img/1_16_1.5d47b476.jpg";